// extracted by mini-css-extract-plugin
module.exports = {"coin":"coin_coin__3j-Ly","coinFront":"coin_coinFront__mu50s","float":"coin_float__8JhRZ"};